import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { serviceDeskPortalSettingsResource } from '@jira/spa-apps__project-settings-service-desk-portal-settings/src/serviceDeskPortalSettingsResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { portalSettingsContextResource } from '@jira/router-resources__service-desk-portal-settings-context/src/portalSettingsContextResource.tsx';
import { projectSettingsServicedeskChannelsPortalRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskChannelsPortalRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import ServiceDeskPortalSettings, {
	LazyProjectSettingsServiceDeskPortalSettings,
} from './ui/service-desk-portal-settings/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskChannelsPortalRouteEntry: Route = createEntry(
	projectSettingsServicedeskChannelsPortalRoute,
	() => ({
		group: 'project-settings-servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskPortalSettings,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			portalSettingsContextResource,
			serviceDeskPortalSettingsResource,
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskPortalSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
